import { ApplicationRef } from '@angular/core';
import { BaseSecurityPageModule } from 'SecuritiesApp/ts/apps/base-security-page/app.module';
import { HoldingsAllHoldingsModule } from 'SecuritiesApp/ts/features/holdings-all-holdings/holdings-all-holdings.module';
import { TopBarNavComponent } from 'Angular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { SideMenuComponent } from 'Angular/features/components/side-menu/side-menu.component';
import { HoldingsAllHoldingsComponent } from 'SecuritiesApp/ts/features/holdings-all-holdings/holdings-all-holdings.component';
import { SecurityHeaderControlComponent } from 'SecuritiesApp/ts/features/security-header-control/security-header-control.component';
import { StoreDevtoolsModule } from 'Angular/state/store-devtools/store-devtools.development';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store-devtools";
export class MutualFundsHoldingsAllHoldingsModule {
    ngDoBootstrap(appRef) {
        appRef.bootstrap(HoldingsAllHoldingsComponent);
        appRef.bootstrap(SideMenuComponent);
        appRef.bootstrap(SecurityHeaderControlComponent);
        appRef.bootstrap(TopBarNavComponent);
    }
}
MutualFundsHoldingsAllHoldingsModule.ɵfac = function MutualFundsHoldingsAllHoldingsModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MutualFundsHoldingsAllHoldingsModule)(); };
MutualFundsHoldingsAllHoldingsModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: MutualFundsHoldingsAllHoldingsModule });
MutualFundsHoldingsAllHoldingsModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BaseSecurityPageModule, HoldingsAllHoldingsModule, StoreDevtoolsModule] });
